export default "__VITE_ASSET__B61Odl1J__"